// import { BrowserRouter } from "react-router-dom";
// import WebsiteRoutes from "./routes/WebsiteRoutes";
// import AdminRoutes from "./routes/AdminRoutes";
// import AuthProvider from "./context/AuthContext";
// import 'bootstrap/dist/css/bootstrap.min.css';
// function App() {
//   return (
//     <BrowserRouter>
//       <AuthProvider>
//         <WebsiteRoutes />
//         <AdminRoutes />
//       </AuthProvider>
//     </BrowserRouter>
//   );
// }

// export default App;

import { BrowserRouter, Routes, Route } from "react-router-dom";
import WebsiteRoutes from "./routes/WebsiteRoutes";
import AdminRoutes from "./routes/AdminRoutes";
import AuthProvider from "./context/AuthContext";
import ScrollToTop from "./components/ScrollToTop ";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'; // or fonts.css
import CookieConsent from "./components/layout/CookieConsent";
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
          <CookieConsent />
        <Routes>
          {/* Public Website */}
          <Route path="/*" element={<WebsiteRoutes />} />

          {/* Admin Section */}
          <Route path="/admin/*" element={<AdminRoutes />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;